export * from './base-modal.component';
